import React from "react";
import EditCell from "../EditableCell";
import { ACCESSORS } from "../../../../constants";
import { Wrapper } from "./styled";

const FiscalValue = ({ handleChange, row, defVal }) => {
  if (!row.original.inputs.showFiscalValue) {
    return null;
  }

  return (
    <Wrapper>
      <EditCell handleChange={handleChange} row={row} name={ACCESSORS[3]} defVal={defVal} />
    </Wrapper>
  );
};

export default FiscalValue;
